var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": _vm.transition.enter,
        "leave-active-class": _vm.transition.leave,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isActive,
              expression: "isActive",
            },
          ],
          staticClass: "snackbar",
          class: [_vm.type, _vm.position],
        },
        [
          _c("p", {
            staticClass: "text",
            domProps: { innerHTML: _vm._s(_vm.message) },
          }),
          _vm.actionText
            ? _c(
                "div",
                {
                  staticClass: "action",
                  class: _vm.type,
                  on: { click: _vm.action },
                },
                [
                  _c("button", { staticClass: "button is-dark" }, [
                    _vm._v(_vm._s(_vm.actionText)),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }